import type { LitterWhereInput } from '@gql/graphql';
import type { BreederListPageFormValues } from '@presentation/pages';
import { useCallback } from 'react';

export const useLitterWhereBuilder = () => {
  const litterWhereBuilder = useCallback((form: BreederListPageFormValues): LitterWhereInput => {
    const whereInputs: LitterWhereInput[] = [
      {
        adminValidated: { equals: true },
      },
      {
        archived: { equals: false },
      },
    ];

    whereInputs.push({
      dogBreed: {
        is: {
          OR: [{ name: { in: form.breedNames } }, { baseBreedName: { in: form.breedNames } }],
        },
      },
    });

    return { ...(whereInputs.length ? { AND: whereInputs } : {}) } as LitterWhereInput;
  }, []);

  return { litterWhereBuilder };
};
